"use strict";
let {flex, FlexApiRequest, _} = window;
let {React} = flex.lib;
let {ValidatedForm} = flex.components;
let ValidatorTypes = ValidatedForm.ValidatorTypes;
let RegexTypes = ValidatedForm.RegexTypes;

import { CONTACT_US } from '../../constants/resources';

class ContactUs extends ValidatedForm {
    constructor(props) {
        super(props);

        this.state = {
            form: {
                reason: {value: '', valid: true},
                title: {value: '', valid: true},
                firstName: {
                    value: undefined,
                    validators: [{type: ValidatorTypes.Required}, {type: ValidatorTypes.Regex, value: RegexTypes.Name}],
                    valid: true
                },
                lastName: {
                    value: undefined,
                    validators: [{type: ValidatorTypes.Required}, {type: ValidatorTypes.Regex, value: RegexTypes.Name}],
                    valid: true
                },
                email: {
                    value: undefined,
                    validators: [
                        {

                            type: ValidatorTypes.Required
                        },
                        {
                            type: ValidatorTypes.Regex,
                            value: RegexTypes.Email
                        }
                    ],
                    valid: true
                },
                phone: {
                    value: undefined, 
                    validators: [{type: ValidatorTypes.Regex, value: RegexTypes.Phone, allowNullOrUndefined: true}], 
                    valid: true
                },
                company: {value: undefined, valid: true},
                message: {value: undefined, validators: [{type: ValidatorTypes.Required}], valid: true}
            },
            response: ""
        };


    }

    handleSubmit() {
        // some logic to handle form submission
        let activeSpinner = flex.showSpinner(document.querySelector('.ladda-button'));
        let form = this.state.form;

        let request = {
            reason: form.reason.value,
            title: form.title.value,
            firstName: form.firstName.value,
            lastName: form.lastName.value,
            email: form.email.value,
            phone: form.phone.value,
            company: form.company.value,
            message: form.message.value
        };

        FlexApiRequest.POST({path: '/api/v1/post/submitcontactusform'})
            .send(request)
            .then(() => {
                console.log("Contact form sent!");
                this.setState({response: "Thank you for submitting your request. A customer service representative will be contacting you shortly."});
                flex.hideSpinner(activeSpinner);
            })
            .catch(error => {
                this.setState({response: "There was an error while processing your request, please try again later!"});
                flex.hideSpinner(activeSpinner);
            });

        console.log(`Submitting Contact Us Form: ${JSON.stringify(form)}`);
    }

    fetchPerson() {
        let store = flex.getStore().toJS();

        FlexApiRequest.POST({path: '/api/v1/org/getpersonfromcontext'})
            .send({})
            .then(({data}) => {
                if (!(data && data.person)) {
                    return;
                }
                let {person = {}} = data,
                    {contactMethods = [], firstName, lastName} = person,
                    email = _.find(contactMethods, {'isPrimary': true, 'kind': 'Email'}) || {},
                    phone = _.find(contactMethods, {'isPrimary': true, 'kind': 'Phone'}) || {},
                    {form} = this.state;


                form.email.value = email.value;
                form.phone.value = phone.value;
                form.firstName.value = firstName;
                form.lastName.value = lastName;
                form.company.value = store.appContext.userContext.currentContext.userOrg.summary;
                this.setState({form});
            })
    }

    componentDidMount() {
        const store = this.props.store;

        if (store && store.session) {
            this.fetchPerson();
        }
    }

    redirectToDefaultRoute() {
        window.location = "/";
    }

    render() {
        let form = this.state.form;

        let response = <section className="container">
            <h1>Contact Us</h1>
            <h4>{this.state.response}</h4>
            <a onClick={this.redirectToDefaultRoute}>Click here to continue</a>
            <div className="row">&nbsp;</div>
        </section>;

        if (this.state.response) {
            return response;
        }

        return (<section className="container" role="main">
            <h1>Contact Us</h1>

            <h4>You can contact us by completing the fields below and clicking submit</h4>

            <p className="contact-intro">{CONTACT_US.INTRO_TEXT}</p>
            <p className="">Arbitrations must be submitted by clicking the arbitration link on the purchase history page. Arbitrations may not be submitted through the 'contact us' page.</p>                           
             <form id="contact-us-form" className="contact-us-form validate-form">                
                <div className="row">
                    <div className="form-group select col-sm-6">
                        <label className="control-label" htmlFor="cu-reason">Contact Reason</label>
                        <select className="form-control" id="cu-reason" name="reason" value={form.reason.value} onChange={this.handleChange.bind(this)}>
                            <option value="">Select</option>
                            <option value="General Questions">General Questions</option>
                            <option value="Technical issues">Technical Issues</option>
                        </select>
                    </div>

                    <div className="form-group select col-sm-6">
                        <label className="control-label" htmlFor="cu-title">Title</label>
                        <select className="form-control" id="cu-title" name="title" value={form.title.value} onChange={this.handleChange.bind(this)}>
                            <option value="">Select</option>
                            <option value="Mr.">Mr.</option>
                            <option value="Mrs.">Mrs.</option>
                            <option value="Ms.">Ms.</option>
                        </select>
                    </div>
                </div>

                <div className="row">
                    <div className={form.firstName.valid ? "form-group text col-sm-6" : "form-group text col-sm-6 has-error"}>
                        <label className="control-label" htmlFor="cu-first-name">First Name <sup title="Required">*</sup>
                            { form.firstName.valid ? false : <span id="cu-first-name-error" className="error">This field is required.</span> }
                        </label>
                        <input className="form-control" value={form.firstName.value} id="cu-first-name" name="firstName" type="text"
                               onChange={this.handleChange.bind(this)} onBlur={this.handleChange.bind(this)}/>
                    </div>

                    <div className={form.lastName.valid ? "form-group text col-sm-6" : "form-group text col-sm-6 has-error"}>
                        <label className="control-label" htmlFor="cu-last-name">Last Name <sup title="Required">*</sup>
                            { form.lastName.valid ? false : <span id="cu-last-name-error" className="error">This field is required.</span> }
                        </label>
                        <input className="form-control" value={form.lastName.value} id="cu-last-name" name="lastName" type="text"
                               onChange={this.handleChange.bind(this)} onBlur={this.handleChange.bind(this)}/>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12 col-md-6">
                        <div className="row">
                            <div className={ form.email.valid ? "form-group text col-sm-6 col-md-8" : "form-group text col-sm-6 col-md-8 has-error" }>
                                <label className="control-label" htmlFor="cu-email">Email <sup title="Required">*</sup>
                                    { form.email.valid ? false : <span id="cu-last-email-error" className="error">This field is required.</span> }
                                </label>
                                <input className="form-control" value={form.email.value} id="cu-email" name="email" type="text"
                                       onChange={this.handleChange.bind(this)} onBlur={this.handleChange.bind(this)}/>
                            </div>

                            <div className={form.phone.valid ? "form-group text col-sm-6 col-md-4" : "form-group text col-sm-6 col-md-4 has-error"}>
                                <label className="control-label" htmlFor="cu-phone">Phone</label>
                                <input className="form-control" value={form.phone.value} id="cu-phone" name="phone" type="text"
                                       onChange={this.handleChange.bind(this)}/>
                            </div>
                        </div>
                    </div>

                    <div className="form-group text col-sm-6">
                        <label className="control-label" htmlFor="cu-company">Company</label>
                        <input id="cu-company"
                               className="form-control"
                               name="company"
                               type="text"
                               value={form.company.value}
                               onChange={this.handleChange.bind(this)}
                               onBlur={this.handleChange.bind(this)}/>
                    </div>
                </div>

                <div className={form.message.valid ? "form-group textarea" : "form-group textarea has-error"}>
                    <label className="control-label" htmlFor="cu-message">Message <sup title="Required">*</sup>
                        { form.message.valid ? false : <span id="cu-message-error" className="error">This field is required.</span> }
                    </label>
                    <textarea className="form-control" value={form.message.value} id="cu-message" name="message" rows="8" cols="48"
                              placeholder="Enter your message here" onChange={this.handleChange.bind(this)} onBlur={this.handleChange.bind(this)}>
                    </textarea>
                </div>

                <div className="row">
                    <div className="col-xs-6 col-sm-5 col-sm-offset-4 col-md-4 col-md-offset-6">
                        <a className="btn btn-cancel" onClick={this.redirectToDefaultRoute}>Cancel</a>
                    </div>

                    <div className="col-xs-6 col-sm-3 col-md-2">
                        <a className="btn ladda-button"
                           onClick={this.validateForm.bind(this, form, this.handleValidation.bind(this), this.handleSubmit.bind(this)) }>Submit</a>
                    </div>
                </div>
            </form>
        </section>);
    }

}

export default ContactUs;
